export default __webpack_public_path__ + "static/media/PP-logo-white.c76aab7c.svg";